import React from "react";
import Logo from "./Logo";
import Search from "../search/Search";
import ToolBox from "./ToolBox";
import "./header.scss";
const Header = ({ children }) => {
  return (
    <div className="site_header">
      <div className="site_header_left">
        <Logo href="/" />
      </div>
      <div className="site_header_middle">
        <Search />
      </div>
      <div className="site_header_right">
        <ToolBox />
      </div>
    </div>
  );
};

export default Header;
